import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import {
	GetCategoryDataResponse,
	GetPrimarySectorsDataResponse,
	UpdateCategoryDataProps,
} from './types/category.interfaces'
import {
	DefaultGetParamsProps,
	GenerateCategoryPromptDataResponse,
} from './types/interfaces'

const URL = '2/categories'
const URL_SEARCH = '2/search'

export const CategoryService = {
	async get({ id }: DefaultGetParamsProps): Promise<GetCategoryDataResponse> {
		const response: AxiosResponse<GetCategoryDataResponse> =
			await apiNode.get<GetCategoryDataResponse>(`${URL}/${id}`)
		return response.data
	},
	async create({ data }: { data: UpdateCategoryDataProps }) {
		return apiNode.post(`${URL}/create`, data)
	},
	async update({ data, id }: { data: UpdateCategoryDataProps; id: string }) {
		return apiNode.patch(`${URL}/${id}/update`, data)
	},
	async delete({ id }: DefaultGetParamsProps) {
		return apiNode.delete(`${URL}/${id}/delete`)
	},
	async promptGenerate({ text }: { text: string }) {
		return apiNode.post<GenerateCategoryPromptDataResponse>(
			`${URL_SEARCH}/prompt-generator`,
			{ text },
		)
	},
	async getPrimarySectors(): Promise<GetPrimarySectorsDataResponse> {
		const response: AxiosResponse<GetPrimarySectorsDataResponse> =
			await apiNode.get<GetPrimarySectorsDataResponse>(`${URL}/primary-sectors`)
		return response.data
	},
}
